import React from 'react';
import shipping1 from 'assets/img/shipping1.png';
import shipping2 from 'assets/img/shipping2.png';
import shipping3 from 'assets/img/shipping3.png';
import payment1 from 'assets/img/payment1.png';
import payment2 from 'assets/img/payment2.png';
import payment3 from 'assets/img/payment3.png';

import 'assets/screens.scss';
import './style.scss';

const DeliveryScene = () => (
	<div className="delivery-layout">
    <h1 className="delivery-layout__caption">Доставка и оплата</h1>
    <div className="delivery-layout__list">
      <div className="delivery-layout__block">
        <img alt="Доставка" className="delivery-layout__block__img" src={shipping1} />
        <div className="delivery-layout__block__text"><span>Самовывоз</span> осуществляется по адресу г. Ярославль, ул. Полушкина роща, д. 5</div>
      </div>
      <div className="delivery-layout__block">
        <img alt="Оплата" className="delivery-layout__block__img" src={payment1} />
        <div className="delivery-layout__block__text">Оплата товара при самовывозе осуществляется <span>наличными при получении</span></div>
      </div>
      {/*TODO add CDEC back*/}
      {/*<div className="delivery-layout__block">*/}
        {/*<img alt="Доставка" className="delivery-layout__block__img" src={shipping2} />*/}
        {/*<div className="delivery-layout__block__text"><a rel="noopener noreferrer" target="_blank" href="http://cdek.ru/">Службой доставки &laquo;СДЭК&raquo;</a> - доставка до офиса компании в вашем городе или курьером по указанному адресу</div>*/}
      {/*</div>*/}
      {/*<div className="delivery-layout__block">*/}
        {/*<img alt="Оплата" className="delivery-layout__block__img" src={payment2} />*/}
        {/*<div className="delivery-layout__block__text">Оплата в этом случае осуществляется <span>наличными или банковской картой при получении</span></div>*/}
      {/*</div>*/}
      <div className="delivery-layout__block">
        <img alt="Доставка" className="delivery-layout__block__img" src={shipping3} />
        <div className="delivery-layout__block__text"><span>Транспортной компанией по вашему выбору</span> - доставка до офиса транспортной компании в вашем городе или курьером (при наличии офиса ТК в г. Ярославле)</div>
      </div>
      <div className="delivery-layout__block">
        <img alt="Оплата" className="delivery-layout__block__img" src={payment3} />
        <div className="delivery-layout__block__text">В этом случае по указанным реквизитам <span>оплачивается 100% стоимости товара</span>, доставка оплачивается при получении</div>
      </div>
    </div>
	</div>
);

export default DeliveryScene;



// WEBPACK FOOTER //
// ./src/scenes/DeliveryScene/index.js